import { Chip } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { DashboardContext } from "../../../DashboardContext/DashboardContextProvider.jsx";
import AdditionalServicesField from "../Inputs/AdditionalServicesField.jsx";
import ListCheckboxes from "../Inputs/ListCheckboxes.jsx";
import NewDate from "../Inputs/NewDate.jsx";
import NewSelect from "../Inputs/NewSelect.jsx";
import RadioGroupField from "../Inputs/RadioGroupField.jsx";
import "../Inputs/styles/list-checkboxes.css";
import "../Inputs/styles/new-text.css";
import { FormContext } from "../context/FormProvider.jsx";
import { scrollToFirstRequiredField } from "../main-helper.js";
import "../styles/form-container.css";
import useSetSlide from "./Hooks/setSlide.jsx";
import useInvalidInputs from "./Hooks/useInvalidInputs.jsx";
import ResponsiveRow from "./ResponsiveRow.jsx";
import "./styles/services.css";

// Slide 2: SWPPP Services
const SWPPPServices = ({ setSlideStatus, slideState, formStateLoaded }) => {
  const [disabledInputs, setDisabledInputs] = useState([]);
  const {
    slide3,
    setSlide3,
    setIsLoading,
    requestStatus,
    populateInvalidInputs,
    getInvalidData,
    getInputMessage,
    disabledInputCheck,
  } = useContext(FormContext);

  const { clientId, projectId } = useContext(DashboardContext);

  // On Mount, the page should scroll to the top
  useEffect(() => {
    scrollToFirstRequiredField(slide3);
  }, []);

  // Update Slide State
  const slide3Mutation = useSetSlide(
    clientId,
    projectId,
    3,
    setIsLoading,
    setSlideStatus,
  );

  // Get Invalid Inputs
  const invalidInputsData = useInvalidInputs(
    clientId,
    projectId,
    requestStatus,
  );

  // Populate Invalid Inputs
  useEffect(() => {
    populateInvalidInputs(
      invalidInputsData,
      disabledInputs,
      setDisabledInputs,
      "3",
    );
  }, [invalidInputsData.data, invalidInputsData.isFetched]);

  const [servicesArray, setServicesArray] = useState([]);

  useEffect(() => {
    if (slide3.specialServices && slide3.specialServices.length > 0) {
      setServicesArray(slide3.specialServices.split(", "));
    }
  }, [slide3]);

  return (
    <>
      {formStateLoaded ? (
        <>
          <RadioGroupField
            idProp="swpppServicesRequest"
            label="Are you interested in SWPPP Services?"
            state={slide3}
            setState={setSlide3}
            debouncedSave={slide3Mutation}
            disabledInput={false}
            setIsLoading={setIsLoading}
          />
          {slide3.swpppServicesRequest !== "No" && (
            <>
              <h2 className="question-section">Primary Services</h2>
              <div className="input-list-checkbox-container">
                {slide3.notPreparationRequest && (
                  <p className="important-text">
                    *Argus can only prepare a Notice of Termination (NOT)
                    template, but cannot submit the NOT; it must be submitted by
                    the permitee*
                  </p>
                )}
                <ResponsiveRow type="close-center">
                  <ListCheckboxes
                    label="NOI"
                    idProp="noiRequest"
                    state={slide3}
                    setState={setSlide3}
                    val={slide3.noiRequest}
                    disabledInput={false}
                    setIsLoading={setIsLoading}
                    debouncedSave={slide3Mutation}
                  />
                  <ListCheckboxes
                    label="LVV Checklist"
                    idProp="lvvChecklistRequest"
                    state={slide3}
                    setState={setSlide3}
                    val={slide3.lvvChecklistRequest}
                    disabledInput={false}
                    setIsLoading={setIsLoading}
                    debouncedSave={slide3Mutation}
                  />
                  <ListCheckboxes
                    label="NOT"
                    idProp="notPreparationRequest"
                    state={slide3}
                    setState={setSlide3}
                    val={slide3.notPreparationRequest}
                    disabledInput={false}
                    setIsLoading={setIsLoading}
                    debouncedSave={slide3Mutation}
                  />
                  <ListCheckboxes
                    label="SWPPP Preparation"
                    idProp="swpppPreparationRequest"
                    state={slide3}
                    setState={setSlide3}
                    val={slide3.swpppPreparationRequest}
                    disabledInput={false}
                    setIsLoading={setIsLoading}
                    debouncedSave={slide3Mutation}
                  />
                  <ListCheckboxes
                    label="Inspections"
                    idProp="swpppInspectionRequest"
                    state={slide3}
                    setState={setSlide3}
                    val={slide3.swpppInspectionRequest}
                    disabledInput={false}
                    setIsLoading={setIsLoading}
                    debouncedSave={slide3Mutation}
                  />
                  <ListCheckboxes
                    label="Posting Notice Sign"
                    idProp="postingNoticeSignRequest"
                    state={slide3}
                    setState={setSlide3}
                    val={slide3.postingNoticeSignRequest}
                    disabledInput={false}
                    setIsLoading={setIsLoading}
                    debouncedSave={slide3Mutation}
                  />
                </ResponsiveRow>
                {slide3.noiRequest && (
                  <>
                    <p className="important-text">
                      *NOI must be filed 14 days prior to the start of
                      construction activities*
                    </p>
                    <ResponsiveRow type="center">
                      <NewSelect
                        idProp="permittee"
                        label="Permittee"
                        type={"permittee"}
                        val={slide3.permittee}
                        state={slide3}
                        setState={setSlide3}
                        debouncedSave={slide3Mutation}
                        req={slide3.noiRequest && slide3.permittee === ""}
                        setIsLoading={setIsLoading}
                        disabledInput={false}
                        disabledInputMessage={
                          disabledInputCheck("permittee", disabledInputs) ===
                          false
                            ? getInputMessage("permittee", invalidInputsData)
                            : ""
                        }
                        invalidData={getInvalidData(
                          "permittee",
                          invalidInputsData,
                        )}
                      />
                      <NewDate
                        idProp="noiFilingDate"
                        label="NOI file by date"
                        val={slide3.noiFilingDate}
                        state={slide3}
                        setState={setSlide3}
                        debouncedSave={slide3Mutation}
                        req={slide3.noiRequest && slide3.noiFilingDate === ""}
                        setIsLoading={setIsLoading}
                        disabledInput={false}
                        disabledInputMessage={
                          disabledInputCheck(
                            "noiFilingDate",
                            disabledInputs,
                          ) === false
                            ? getInputMessage(
                                "noiFilingDate",
                                invalidInputsData,
                                "3",
                              )
                            : ""
                        }
                        invalidData={getInvalidData(
                          "noiFilingDate",
                          invalidInputsData,
                          "3",
                        )}
                      />
                    </ResponsiveRow>
                  </>
                )}
              </div>
            </>
          )}
          <h2 className="question-section">Additional Services</h2>
          <ResponsiveRow type="center">
            <AdditionalServicesField
              idProp="specialServices"
              label="Select additional services"
              type={"specialServices"}
              val={servicesArray}
              state={slide3}
              setState={setSlide3}
              debouncedSave={slide3Mutation}
              setIsLoading={setIsLoading}
              disabledInput={false}
              invalidData={getInvalidData(
                "specialServices",
                invalidInputsData,
                "3",
              )}
              servicesArray={servicesArray}
              setServicesArray={setServicesArray}
            />
          </ResponsiveRow>
          {servicesArray && servicesArray.length > 0 && (
            <>
              <h2 className="question-section">Requested Services</h2>
              <ResponsiveRow type="close-center">
                {servicesArray.map((service) => (
                  <Chip
                    className="service"
                    key={service}
                    id={`service-chip`}
                    label={service}
                    classes={{
                      deleteIcon: "service-delete-icon",
                      label: "service-chip-label",
                    }}
                    onDelete={() => {
                      let newArr = servicesArray.filter((s) => s !== service);
                      setServicesArray((prev) =>
                        prev.filter((s) => s !== service),
                      );
                      setSlide3((prev) => ({
                        ...prev,
                        specialServices: newArr.join(", "),
                      }));
                      setIsLoading(true);
                      slide3Mutation.mutate({
                        ...slide3,
                        specialServices: newArr.join(", "),
                      });
                    }}
                  />
                ))}
              </ResponsiveRow>
            </>
          )}
        </>
      ) : (
        <p className="slide-loading">Loading...</p>
      )}
    </>
  );
};

export default SWPPPServices;
